import Action from '../../Action'
import './styles/ModalCreateException.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import SelectorIcons from '../../SelectorIcons';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import { TimeFormatter } from "../../../utils/utils";
import { logAuditAction } from '../../../utils/auditLogger';
const ModalCreateTrigger =({buscar_cis,handleShowPopup,setSearchTerm,languaje,mode,user,dataUsers,devices,server,setRegisterIsValid,groupSelected,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal})=>{
    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    const [host,sethost]=useState([])
    const [ManttoData,setManttoData]=useState({
        // name_brand:(editActive)?groupSelected.name_brand:"",
        metric_id: (editActive)?groupSelected.metric_id:0,
        name: (editActive)?groupSelected.name:"",
        description: (editActive)?groupSelected.description:"",
        min_value: (editActive)?groupSelected.min_value:"",
        max_value: (editActive)?groupSelected.max_value:"",
       delay:(editActive)?TimeFormatter(groupSelected.delay):""
        })
    const reqField=()=>{
        return(
          <p className='reqField-gs'>
            *
          </p>
        )
      }
    const [hostName,setHostName]=useState("")
    const [hostLocation,setHostLocation]=useState("")
    const [hostActivate,setHostActivate]=useState(0)
    const levelsActual = dataUsers.data.map(obj => obj.level)
    const iconsActualString = dataUsers.data.map(obj => obj.icon)
    const iconsActual= iconsActualString.map(Number)
    // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
    const [msgError,setMsgError]=useState("")
    const [listSearchIP,setListSearchIP]=useState(false)
    const dataMetric=useFetch('cassia/device_metrics/triggers','','','GET',server)

    const handleChange=(e)=>{
        const {name,value}=e.target
        if(e.target.name==="criticality"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value===""?0:(parseInt(value))
                }
                
            })
        }  else if(e.target.name==="status"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:(value=="Inactivo")?"Activo":"Inactivo"
                }
                
            })
        }else{
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value
                }
                
            })
        }



        if(e.target.name==="ip"){
            if(value==""){
                setHostLocation("")
                setHostActivate(0)
                setIpValid(true)
                sethost([])
                setHostName("")
                setHostLocation("")
            }else{
                setIpValid(validateIp(value))
            }
           
           
          }
    }

    useEffect(()=>{
        if( ManttoData.metric_id==0 || ManttoData.name==""  || ManttoData.description=="" ||
           ManttoData.min_value===""  || ManttoData.max_value==="" || ( parseInt(ManttoData.max_value)<=parseInt(ManttoData.min_value))
        ){
            setDisabled(true)
        }else{
            setDisabled(false)
        }
    },[ManttoData])


    const Registrar=()=>{
        let method='POST'
        let url_add=''
        if(editActive){
            method='PUT'
            url_add=groupSelected.id
        }

        let  body ={
        // name_brand:(editActive)?groupSelected.name_brand:"",
        metric_id: ManttoData.metric_id,
        name:ManttoData.name,
        description: ManttoData.description,
        min_value: ManttoData.min_value,
        max_value: ManttoData.max_value,
       delay:(durationToSeconds(ManttoData.delay)==0 || ManttoData.delay=="" )?null:durationToSeconds(ManttoData.delay)
        }



        setLoading(true)
        const fetchDataPost = async () => {
          
       try {
           // console.log(localStorage.getItem('access_token'))
           const response = await fetch(server.url+'/api/v1/cassia/device_metrics/triggers/'+url_add, {
             method: method,  
             headers: {
                "Accept": "application/json",
               // 'Content-Type': 'application/json',
               'Content-Type': 'application/json',
                 Authorization: `Bearer ${localStorage.getItem('access_token')}`,
               },
             body: JSON.stringify(body),
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoading(false)
             // Manejo de la respuesta
             setData(data1)
             buscar_cis()
             handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
             // console.log(data1);
             closCreateCisModal()
           setRegisterIsValid(true)
           
           const timer = setTimeout(() => {
             setRegisterIsValid(false)
             setEditActive(false)
             closCreateCisModal()
           }, 3000);
         
           } else {
             const data1 = await response.json();
             handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),(typeof response.detail === "string")?data1.detail:data1.detail[0].msg, false)
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
              setHostName("")
              setManttoData({type_id:0,name:""})
              
          setLoading(false)
            // Manejo de errores
            setError(error)
            closCreateCisModal()
            setRegisterIsValid(true)
          //   handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
            const timer = setTimeout(() => {
              setRegisterIsValid(false)
              setEditActive(false)
              closCreateCisModal()
            }, 3000);
            console.error(error);
          }
        };

        fetchDataPost();
    }

    const buscar_host=(ip)=>{
        setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
           const response = await fetch(server.url+'/api/v1/cassia/ci_elements/search_host/'+ip, {
               method: 'GET',  
               headers: {
                 'Content-Type': 'application/json',
                 'accept': 'application/json',
                 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
               },
             });
           //   console.log(response)
           if (response.ok) {
               const data1 = await response.json();
               setLoadingM(false)
               if(data1.data.length==0){
                   sethost([])
               setHostName("")
               setHostLocation("")
               setHostActivate(0)
                   setMsgError("La IP no existe o no esta dada de alta")
                   setIpValid(false)
               }else{
                   setIpValid(true)

               }
               sethost(data1.data)
               setDisabled(true)
           } else {
               const data1 = await response.json();
               throw new Error('Error en la solicitud');
           }
       } catch (error) {
            console.error(error);
          }
        };

        fetchDataPost();
    }
    const [triggerId,setTriggerId]=useState(0)
    const changeOption=(option,index)=>{
        
        setTriggerId(option.value)

        // setManttoData((prevState)=>{
        //     return {
        //         ...prevState,
        //         ["metric_id"]:option.value===""?0:(parseInt(option.value))
        //     }
            
        // })
        // setManttoRelation(option.value)
            
    }

    const [fecha, setDate] = useState('2023-09-28')
    const validateIp= (ip) => {
        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        if(result){
            buscar_host(ip)
        }else{
            setHostLocation("")
            setMsgError("Direccion ip no valida")
            sethost([])
                setHostName("")
                setHostLocation("")
                setHostActivate(0)
        }
        return result;
    };
    const [resultList,setResultList]=useState([])


    //   console.log(resultList)

    const closeListSearch=()=>{
        setListSearchIP(false)
    }
    const handleKeyPress = (e) => {
      // Permitir solo números, teclas de control y el punto decimal
      const charCode = e.charCode;
      if (
        (charCode >= 48 && charCode <= 57) || // Números 0-9
        charCode === 46 || // Punto decimal
        charCode === 8 || // Retroceso
        charCode === 37 || // Flecha izquierda
        charCode === 39 ||// Flecha derecha
        charCode === 45 //  negativo
      ) {
        return;
      } else {
        e.preventDefault();
      }
    };
    const handlePaste = (e) => {
      const paste = (e.clipboardData || window.clipboardData).getData('text');
      if (!/^-?\d*\.?\d*$/.test(paste)) {
        e.preventDefault();
      }
    };
    const handleTimeChange = (event) => {
        const inputValue = event.target.value;
        const regex =/^[0-9hms\s]*$/;

        // Permitir solo caracteres válidos
        if (regex.test(inputValue)) {
          // Remover espacios duplicados
          
          const formattedValue = inputValue.replace(/\s+/g, ' ').trim();
         setManttoData((prevState)=>{
                    return {
                        ...prevState,
                        [event.target.name]:inputValue
                    }
                    
                })
               
        }
    };

    const validaDelay = (event) => {
      const valRegex = /^(\d+h\s*)?(\d+m\s*)?(\d+s\s*)?$/;
       if (valRegex.test(event)) {
        return true
          }else{
            return false
          }
      
    }
    function durationToSeconds(duration) {
  const regex = /(\d+h)?\s*(\d+m)?\s*(\d+s)?/;
  const matches = duration.match(regex);
  
  if (!matches) return 0;
  
  const hours = matches[1] ? parseInt(matches[1].replace('h', '')) : 0;
  const minutes = matches[2] ? parseInt(matches[2].replace('m', '')) : 0;
  const seconds = matches[3] ? parseInt(matches[3].replace('s', '')) : 0;
  
  return (hours * 3600) + (minutes * 60) + seconds;
}

    const Eliminar=()=>{
           
          setLoading(true)
           setLoadingM(true)
             const fetchDataPost = async () => {
               
            try {
                const response = await fetch(server.url+'/api/v1/cassia/device_metrics/triggers/active/'+triggerId, {
                // const response = await fetch(server.url+'/api/v1/cassia/device_metrics/'+user.id, {
                  method: 'PUT',  
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                  },
                  body:JSON.stringify({
                    "closed_at":""
                  })
                });
                if (response.ok) {
                  
                  const data1 = await response.json();
                  setLoadingM(false)
                  setLoading(false)
                  // Manejo de la respuesta
                  setData(data1)
                  buscar_cis()
                 handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
                  logAuditAction(
                      editActive ? "Editar" : "Crear",
                      `Trigger ID: ${triggerId}`,
                      "Disparadores"
                  );
                  // console.log(data1);
                  closCreateCisModal()
                  
                  // console.log(data1);
                } else {
                    const data1 = await response.json();
                    setLoadingM(false)
                    // closDeleteUserModal()
                    handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regDeleteNoCorr']),data1.detail, false)

                    throw new Error('Error en la solicitud');
                }
            } catch (error) {
                 // Manejo de errores
                 // handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regDeleteNoCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
                 setError(error)
                 console.error(error);
               }
             };
         
             fetchDataPost();
             
       }
    const {metric_id,name,description,min_value,max_value,delay}=ManttoData;
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {((editActive)?lang[languaje]['editar'].toUpperCase():lang[languaje]['crear'].toUpperCase())+' '+lang[languaje]['disparador'].toUpperCase()}
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                
                                    <div className="form-GS-box"> 
                                       <div className="cont-msg-alert-confirm-action">
                            <div className="compact-msg-alert-confirm-action">
                                <img  className='icon-msg-alert' src={"/iconos/warning.png"}alt="Icono" style={{width:'30px',height:'30px',marginRight:'10px'}}/>
                                <div className="msg-alert-txt-confirm-action">

                                    {'Esta es una version DEMO de SAIMONTECH por lo cual no se pueden crear nuevos disparadores, aqui se le proporciona una lista  precargada de disparadores que podra dar de alta.'}
                                </div>
                            </div>
                            
                        </div>

                        { (!dataMetric.loading && dataMetric.data && dataMetric.data.data && dataMetric.data.data.filter(elemento => elemento.active === 0).length === 0) && (
                            <div className="cont-msg-alert-confirm-action" style={{marginTop:'10px', marginBottom:'15px'}}>
                                <div className="compact-msg-alert-confirm-action">
                                    <img className='icon-msg-alert' src={"/iconos/warning.png"} alt="Icono" style={{width:'30px',height:'30px',marginRight:'10px'}}/>
                                    <div className="msg-alert-txt-confirm-action">
                                        {'Se necesitan eliminar disparadores de la tabla para que sean opciones elegibles para esta simulación.'}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* <div className="user-box-GS "  style={{height:'10%'}}>
                                     </div> */}
                                    <div className="user-box-GS "  style={{height:'15%'}}>
                                        {
                                            (dataMetric.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                            <>
                                                { (dataMetric.data && dataMetric.data.data && dataMetric.data.data.filter(elemento => elemento.active === 0).length === 0) ? (
                                                    <div style={{width:'100%', pointerEvents:'none', opacity: 0.5}}>
                                                        <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={0} origen={'Admin'} data={[]} loading={false}  titulo='Triggers' selectFunction={changeOption} index={0}></SelectorAdmin>
                                                    </div>
                                                ) : (
                                                    <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={0} origen={'Admin'} data={dataMetric.data.data.filter(elemento => elemento.active === 0)}   loading={dataMetric.loading}  titulo='Triggers' selectFunction={changeOption} index={0}></SelectorAdmin>
                                                ) }
                                            </>
                                        }
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['disparador'])}{(triggerId==0)?reqField():''}</label>   
                                    </div>
                                     
                                   
                                    
                                    {/* <div className="user-box-GS"  style={{height:'15%'}}>
                                    <input required name="name"  type="text" value={name}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['nombre'])}{(name=="")?reqField():''}</label>
                                        
                                    </div>
                                    <div className="user-box-GS"  style={{height:'15%'}}>
                                    <input required name="description"  type="text" value={description}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['descripcion'])}{(description=="")?reqField():''}</label>
                                        
                                    </div>
                                    <div className="user-box-GS"  style={{height:'15%'}}>
                                   
                                    <input required name="min_value" style={{height:'20%'}}   type="number" value={min_value}
                                    onChange={handleChange} onKeyPress={handleKeyPress} 
                                    onPaste={handlePaste}    />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['minValue'])}{(min_value==="")?reqField():''}</label>
                                        
                                    </div>
                                    <div className="user-box-GS"  style={{height:'15%'}}>
                                 
                                    <input required name="max_value" style={{height:'20%'}}   type="number" min={(min_value!=""?(parseInt(min_value)+parseInt(1)):null)} value={max_value}
                                    onChange={handleChange} onKeyPress={handleKeyPress} 
                                    onPaste={handlePaste}    />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['maxValue'])}{(max_value==="")?reqField():''}</label>
                                        
                                    </div>
                                    <div className="user-box-GS"  style={{height:'15%'}}>
                                                                       <input required name="delay"   type="text" value={delay}
                                                                        onChange={handleTimeChange } 
                                                                        // maxLength="5"
                                                                        placeholder="ejemplos (2h 10m 20s)"  />
                                                                            <label className='label-GS  ' style={{top:'-25%'}}>{"Delay (h,m,s)"}{''}</label>
                                                                            {
                                            (validaDelay(delay))?'':<span className='form-msg-error-admin' style={{bottom: '2%'}}> {'Formato delay no valido, formato: (2h 10m 20s) '}.</span>
                                        }
                                                                        </div>
                                    <div className="user-box-GS"  style={{height:'15%',color:'var(--txt-color)'}}>
                                     { 
                                      (parseInt(max_value)>parseInt(min_value))?
                                      <div style={{color:'var(--txt-color)'}} > 
                                       
                                       
                                       { 'El valor del disparador sera >= '+ min_value +' y <= '+max_value}
                                       
                                      </div>:
                                      <div style={{color:'var(--red-alert)'}} > 
                                      { 
                                       'El valor maximo debe ser mayor al valor minimo'
                                      }
                                     </div>
                                      }
                                   
                                    </div> */}
                                
                                   
                                    
                                    
                                    <div className="user-box-GS" style={{height:'15%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateCisModal}/>
                                            <Action disabled={triggerId==0} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={Eliminar}/>
                                            </>
                                            // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                </div>
                </div>
                </div>
        </div>
    )
}

export default ModalCreateTrigger